/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const widget_ios_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23 11.394c0 .39-.154.762-.43 1.037l-10.14 10.14a1.466 1.466 0 0 1-2.075 0L1.43 13.646a1.467 1.467 0 0 1 0-2.074l3.238-3.238a3.666 3.666 0 1 1 3.666-3.668l3.238-3.238a1.466 1.466 0 0 1 2.074 0l2.059 2.065a3.667 3.667 0 1 0 4.802 4.804l2.065 2.06c.274.274.429.647.429 1.036Z"
    />
  </svg>
)
export default widget_ios_medium
